import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import React from 'react';
import styled from 'styled-components';
import { GuessedPrefillHelperText } from '../views-components/GuessedPrefillHelperText';
import { ValidationText } from '../views/Forms.styles';
import { Data } from './DATA';
import { useSignupData } from './useSignupData';
const ValidationTextHelperMargin = styled.div.withConfig({
  displayName: "useInputValidation__ValidationTextHelperMargin",
  componentId: "sc-1u74gt5-0"
})(["margin-top:0.625rem;margin-bottom:1.3125rem;"]);
export const ValidationTextWrapper = styled.div.withConfig({
  displayName: "useInputValidation__ValidationTextWrapper",
  componentId: "sc-1u74gt5-1"
})([".is--text--error{color:#bf2434 !important;}"]);
export const useInputValidation = ({
  dataKey,
  customValidationError
}) => {
  const {
    isInvalid,
    errorMessage
  } = useSignupData(dataKey);

  const getValidationText = () => {
    if (errorMessage && isInvalid && customValidationError) {
      return customValidationError;
    }

    if (errorMessage && isInvalid) {
      // short term solution
      const shouldShowDefaultMessaging = [Data.FirstName, Data.LastName].includes(dataKey) && !isValidI18nKey(errorMessage);
      return /*#__PURE__*/_jsx(ValidationTextWrapper, {
        children: /*#__PURE__*/_jsx(ValidationText, {
          use: "error",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-selenium": `${dataKey}_validation_message`,
            message: shouldShowDefaultMessaging ? `data.${dataKey}.error.invalid` : errorMessage
          })
        })
      });
    }

    return /*#__PURE__*/_jsx(ValidationTextHelperMargin, {
      children: /*#__PURE__*/_jsx(ValidationText, {
        use: "help",
        children: /*#__PURE__*/_jsx(GuessedPrefillHelperText, {
          dataKey: dataKey
        })
      })
    });
  };

  return {
    getValidationText
  };
};